module.exports = __webpack_public_path__ + "media/application/images/svgs/icon_info-d580d910514641b7ae434d9c63901224.svg";